import { IBookRepository } from "@/repositories/book/bookRepository.types";
import { BookIntervalCode } from "@/types";
import { BookableDatesUseCase } from "./interface/BookableDatesUseCase";
import { IBookableDatesInfo } from "@/domain/entities/book";
import { IResultData } from "@/domain/entities/shared/result";
import useSetResultCodeIfNeeded from "@/use/useSetResultCodeIfNeeded";

export class GetDailyBookableDates implements BookableDatesUseCase {
  private bookRepository: IBookRepository;

  constructor(bookRepository: IBookRepository) {
    this.bookRepository = bookRepository;
  }

  async execute(
    turnId: string,
    getOnBusStopId: string,
    getOffBusStopId: string,
    fetchLatest = false
  ): Promise<IResultData<IBookableDatesInfo[]>> {
    const bookableDatesResult: IResultData<IBookableDatesInfo[]> = {
      isSuccess: false,
      data: [],
    };

    await this.bookRepository
      .getBookableDatesInfos(
        turnId,
        getOnBusStopId,
        getOffBusStopId,
        fetchLatest,
        BookIntervalCode.DAY
      )
      .then((result) => {
        result
          .map((bookableDatesInfos) => {
            bookableDatesResult.isSuccess = true;
            bookableDatesResult.data = bookableDatesInfos;
          })
          .mapErr((error) => {
            useSetResultCodeIfNeeded(bookableDatesResult, error);
            bookableDatesResult.errorMessage = error.message;
          });
      })
      .catch((error) => {
        bookableDatesResult.isSuccess = false;
        bookableDatesResult.errorMessage = error.message;
      });

    return bookableDatesResult;
  }
}
